import { render, staticRenderFns } from "./expressDetail.vue?vue&type=template&id=e2c4ae70&scoped=true&"
import script from "./expressDetail.vue?vue&type=script&lang=ts&"
export * from "./expressDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4ae70",
  null
  
)

export default component.exports